import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { setGlobalLoading } from "../context/LoaderController";
import { fetchReservedDistricts } from "../services/api";
import "../App.css";
import {
  LOCALSTORAGE_SELECTED_STATE_CODE,
  LOCALSTORAGE_SELECTED_STATE_NAME,
  ROUTE_HOME,
  PAGE_TITLE,
  NO_STATE_SELECTED,
} from "../components/constants";

export default function ReservedDistrictsPage() {
  const stateId = localStorage.getItem(LOCALSTORAGE_SELECTED_STATE_CODE);
  const stateName =
    localStorage.getItem(LOCALSTORAGE_SELECTED_STATE_NAME) || "";

  const [reservedDistricts, setReservedDistricts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!stateId) {
      setError(NO_STATE_SELECTED);
      setLoading(false);
      setGlobalLoading(false);
      return;
    }

    let mounted = true;

    const load = async () => {
      try {
        setLoading(true);
        setGlobalLoading(true);

        const res = await fetchReservedDistricts(stateId);

        if (!mounted) return;
        setReservedDistricts(Array.isArray(res) ? res : []);
      } catch {
        if (!mounted) return;
        setError("No reserved districts found.");
      } finally {
        if (mounted) {
          setLoading(false);
          setGlobalLoading(false);
        }
      }
    };

    load();

    return () => {
      mounted = false;
    };
  }, [stateId]);

  if (!stateId) {
    return (
      <div className="main-container">
        <h2>{PAGE_TITLE}</h2>
        <p>
          Select a state on the <Link to={ROUTE_HOME}>Home</Link> page.
        </p>
      </div>
    );
  }

  return (
    <div className="main-container">
      <h2 className="section-title">Reserved Districts</h2>

      <span className="iyc-badge">
        State: <strong>{stateName || stateId}</strong>
      </span>

      {loading && <p>Loading reserved districts…</p>}
      {error && <p className="error-text">❌ {error}</p>}

      {!loading && !error && reservedDistricts.length === 0 && (
        <p>No reserved districts found.</p>
      )}

        {!loading && reservedDistricts.length > 0 && (
          <div className="table-container" style={{ marginTop: "32px" }}>
            <h3 className="section-subtitle">Reserved Districts</h3>
            <table className="common-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>District Name</th>
                </tr>
              </thead>
              <tbody>
                {reservedDistricts.map((d, i) => (
                  <tr key={d.code}>
                    <td>{i + 1}</td>
                    <td>{d.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
}
